import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import { SelectInput } from "./SelectInput";
import { dayNames } from "../constant";
import { getUserDetails } from "../Helper/utils";
import { DAYS, DAYS_TO_INDEX } from "../constant";
import { activeStyle, inactiveStyle, disabledStyle } from "../StyledComponent"

const ToggleDays = ({ doctorSlots, setDoctorSlots, providerId, makeFormDirty, parentId }) => {
  const [days, setDays] = useState([]);
  const [aviableDaysArray, setAviableDaysArray] = useState([])
  const [selectedDay, setSelectedDay] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [selectedDayIndex, setSelectedDayIndex] =useState(-1);

  useEffect(() => {
    let avaibaleDaysWithSlots = new Set();
    let avaiableDays = [];
    if (doctorSlots && doctorSlots.length > 0) {
      setIsActive(true)
      doctorSlots.forEach(slot => {
        avaibaleDaysWithSlots.add(parseInt(slot.dayOfWeek));
      });
    }
    let sortedAvailableDays = Array.from(avaibaleDaysWithSlots).sort((a, b) => a - b);
    sortedAvailableDays.forEach(value => {
      avaiableDays.push(dayNames[value]);
    });
    setSelectedDay('');
    setAviableDaysArray(avaiableDays);

    if (doctorSlots && doctorSlots.length == 0) {
      setIsActive(false);
    }


  }, [doctorSlots])

  useEffect(() => {
    const dayIndex = parseInt(DAYS_TO_INDEX[selectedDay]);
    if (dayIndex >= 0) {
      setSelectedDayIndex(dayIndex);
    }
    else {
      setSelectedDayIndex(-1);
    }
  }, [selectedDay])

  const bulkSlotsSelection = () => {
    const userDetails = getUserDetails()
    const newSlots = doctorSlots?.filter(slot => !days.includes(slot.dayOfWeek));
    const selectedDaySlots = doctorSlots?.filter(slot => parseInt(slot.dayOfWeek) == parseInt(DAYS_TO_INDEX[selectedDay]));
    selectedDaySlots?.map(slot => {
      for (let day of days) {
        const slotDetails = {
          providerId: providerId,
          dayOfWeek: parseInt(day),
          startTime: slot.startTime,
          endTime: slot.endTime,
          split: slot.split,
          slots: slot.slots,
          totalSlots: slot.slots,
          isActive: true,
          bucketType: "InClinicConsults",
          isHomeVisit: false,
          followStrictTimeCapping: true,
          createdBy: userDetails.userId,
          updatedBy: userDetails.userId,
          parentId: parentId
        };
        newSlots.push(slotDetails);
      }
    })
    setDays([]);
    setSelectedDay('');
    setDoctorSlots(newSlots);
    makeFormDirty();
  }

  const handleDaySelection = (e, day) => {
    if (days.includes(day)) {
      const newDays = days.filter((d) => d !== day);
      setDays(newDays);
    } else {
      setDays([...days, day]);
    }
  };

  const handleDelete = () => {
    setDoctorSlots([]);
    setDays([]);
    setSelectedDay('');
  }
  return (

    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-row items-center justify-start gap-4 pt-6 px-6">
        Copy From
        <SelectInput filterArray={aviableDaysArray} setSelectedDay={setSelectedDay} selectedDay={selectedDay} />
        to
        {DAYS.map((day, index) => (
          <div
            className="flex items-center justify-center text-[#A4B0C0] rounded-lg border border-[#A4B0C0] text-[0.75rem] "
            key={day.key}
            value={(index)}
            aria-label={day.key}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); (isActive && (selectedDayIndex != index)) && handleDaySelection(e, index) }}
            style={{
              minWidth: '2rem',
              maxWidth: '2rem',
              height: '2rem',
              fontSize: '0.75rem',
              textTransform: 'unset',
              borderRadius: '25%',
              border: '1px solid',
              cursor: 'pointer',
              ...(days.includes(index) ? activeStyle : inactiveStyle),
              ...((doctorSlots && doctorSlots.length > 0 && (selectedDayIndex != index))? {} : disabledStyle),
            }}
          >
            {day.label}
          </div>
        ))}

        <button className={`flex justify-center border px-4 py-1 rounded-lg ${days.length > 0 ? " border-[#9ACBFF] text-[#0066DC] " : "text-[#A4B0C0] border-[#DBE0E6] bg-[#F5F7F8] "}`}
          disabled={days.length == 0 && selectedDay}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); bulkSlotsSelection() }}>
          Apply
        </button>
      </div>

      <div className={`${doctorSlots && doctorSlots.length > 0 ? "text-[#AE0006]" : "text-[#A4B0C0]"} flex flex-row items-center justify-start gap-4 pt-6 px-6 pr-10 font-medium `} onClick={(e) => { e.preventDefault(); handleDelete() }} >Clear All
        {
          doctorSlots && doctorSlots.length > 0 ?
            <img src="https://views.medibuddy.in/providerUi/assets/deleteIcon.svg" onClick={(e) => { e.preventDefault(); handleDelete() }} width={20} height={20} style={{ cursor: 'pointer' }} alt="Delete" />
            : <img src="https://views.medibuddy.in/providerUi/assets/deleteDisabledIcon.svg" disabled alt="Delete" />
        }

      </div>
    </div>
  );
};

export default ToggleDays;